import React, { Component } from 'react';
import { PureShareButtons, DisplayTypes, defaultClickHandler } from '@ta-interaktiv/react-share-buttons';
import { Waypoint } from 'react-waypoint';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import setFavicon from 'favicon-setter';
import { Helmet } from 'react-helmet';
import { Paywall } from '@ta-interaktiv/react-paywall';
import Tracking from '@ta-interaktiv/react-tracking';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var ScrollTracking = function () { return (React.createElement(Waypoint, { scrollableAncestor: window, onLeave: function (_a) {
        var currentPosition = _a.currentPosition;
        if (currentPosition === Waypoint.above) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'startReading'
            });
        }
    } })); };

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".masthead-module_mastheadComponent__zISTc {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 100;\n  padding: 0;\n  background-color: #fff;\n  color: var(--text-color); }\n\n.inverted {\n  background-color: transparent; }\n\n.masthead-module_grid__rtd65 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: 3rem; }\n  .masthead-module_grid__rtd65 > * {\n    -ms-flex: 1 1 33%;\n        flex: 1 1 33%; }\n\n.masthead-module_logoContainer__iF6T- {\n  display: block; }\n\n.masthead-module_logo__1iu22 {\n  margin: 1.5ex 0;\n  max-height: 3ex;\n  min-width: 3ex;\n  display: none; }\n\n.masthead-module_fullLogo__1JT85 {\n  max-width: 100%; }\n  @media screen and (min-width: 600px) {\n    .masthead-module_fullLogo__1JT85 {\n      display: block; } }\n\n.masthead-module_iconOnly__7GX_L {\n  max-width: 3ex; }\n  @media screen and (max-width: 599px) {\n    .masthead-module_iconOnly__7GX_L {\n      display: block; } }\n\n.masthead-module_middleContent__tOOLs {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  margin: 0 1rem; }\n  @media screen and (max-width: 599px) {\n    .masthead-module_middleContent__tOOLs {\n      display: none; } }\n\n.masthead-module_shareButtons__3daTi {\n  text-align: right;\n  line-height: 1em;\n  white-space: nowrap; }\n\n.masthead-module_mastheadComponent__zISTc + * > *:first-child > *:first-child:before {\n  content: '';\n  display: block;\n  height: 4.5rem; }\n";
var styles = {"mastheadComponent":"masthead-module_mastheadComponent__zISTc","grid":"masthead-module_grid__rtd65","logoContainer":"masthead-module_logoContainer__iF6T-","logo":"masthead-module_logo__1iu22","fullLogo":"masthead-module_fullLogo__1JT85 masthead-module_logo__1iu22","iconOnly":"masthead-module_iconOnly__7GX_L masthead-module_logo__1iu22","middleContent":"masthead-module_middleContent__tOOLs","shareButtons":"masthead-module_shareButtons__3daTi"};
styleInject(css);

var Masthead = function (props) {
    var _a = props.mediaName, mediaName = _a === void 0 ? 'tagesanzeiger' : _a, _b = props.inverted, inverted = _b === void 0 ? false : _b, _c = props.clickHandler, clickHandler = _c === void 0 ? function () { } : _c, _d = props.homepage, homepage = _d === void 0 ? '//www.tagesanzeiger.ch' : _d, _e = props.fullMediaName, fullMediaName = _e === void 0 ? 'Tages-Anzeiger' : _e, url = props.url;
    var invertedClass = inverted ? 'inverted' : '';
    var invertedImgSrcName = inverted ? '-inverted' : '';
    return (React.createElement("div", { className: "ta-masthead masthead-component " + invertedClass + " " + styles.mastheadComponent },
        React.createElement("div", { className: 'ui container ' },
            React.createElement("div", { className: styles.grid },
                React.createElement("a", { href: homepage, className: styles.logoContainer },
                    React.createElement("img", { src: "//interaktiv.tagesanzeiger.ch/static/icons/" + mediaName + invertedImgSrcName + ".svg", alt: fullMediaName, className: styles.iconOnly }),
                    React.createElement("img", { src: "//interaktiv.tagesanzeiger.ch/static/logos/" + mediaName + invertedImgSrcName + ".svg", alt: fullMediaName, className: styles.fullLogo })),
                React.createElement("div", { className: styles.middleContent }, props.children),
                React.createElement("div", { className: styles.shareButtons },
                    React.createElement(PureShareButtons, __assign({}, props, { url: url, clickHandler: clickHandler, displayType: DisplayTypes.HORIZONTAL_ICONS }))))),
        React.createElement(ScrollTracking, null)));
};

var requestState;
(function (requestState) {
    requestState["LOADING"] = "loading";
    requestState["ERROR"] = "error";
    requestState["READY"] = "ready";
})(requestState || (requestState = {}));
var API_ENDPOINT = 'm';
var PolymorphicMasthead = (function (_super) {
    __extends(PolymorphicMasthead, _super);
    function PolymorphicMasthead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.parsedHostname = parseHostname();
        _this.articleId = _this.props.articleId;
        _this.state = {
            locale: _this.props.locale,
            loadingState: requestState.LOADING,
            clickHandler: _this.props.clickHandler,
            homepage: _this.props.homepage || "//www." + _this.parsedHostname.publicationDomain,
            mediaName: _this.props.mediaName || _this.parsedHostname.publicationName,
            fullMediaName: _this.props.fullMediaName || '',
            title: window.document.title.toString(),
            paywallStatus: 0
        };
        return _this;
    }
    PolymorphicMasthead.prototype.render = function () {
        if (this.state.loadingState === requestState.LOADING) {
            return (React.createElement(Masthead, __assign({}, this.props, this.state), this.props.children));
        }
        return (React.createElement(Masthead, __assign({}, this.props, this.state),
            React.createElement(React.Fragment, null,
                React.createElement(Helmet, { titleTemplate: "%s " + (this.state.fullMediaName ? '| ' + this.state.fullMediaName : '') },
                    React.createElement("html", { lang: this.state.locale + "-CH" }),
                    React.createElement("link", { rel: 'canonical', href: "https://www." + this.parsedHostname.publicationDomain + "/" + this.articleId }),
                    React.createElement("meta", { property: 'og:url', content: "https://www." + this.parsedHostname.publicationDomain + "/" + this.articleId }),
                    React.createElement("title", null, this.state.title)),
                this.props.enablePaywall &&
                    this.state.loadingState === requestState.READY &&
                    this.state.paywallConfiguration && (React.createElement(Paywall, { isEnabled: this.props.enablePaywall, paywallContainerId: this.props.paywallContainerId, paywallConfiguration: this.state.paywallConfiguration, paywallStatus: this.state.paywallStatus })),
                this.state.loadingState === requestState.READY &&
                    this.state.statisticsConfigs && (React.createElement(Tracking, { articleId: this.props.articleId, gtmId: this.state.gtmId, statisticsConfigs: this.state.statisticsConfigs })),
                this.props.children)));
    };
    PolymorphicMasthead.prototype.componentDidMount = function () {
        var _this = this;
        setFavicon("//www." + (this.props.mediaName ||
            this.parsedHostname.publicationName) + ".ch/favicon.ico");
        return fetch("//" + API_ENDPOINT + "." + this.parsedHostname.publicationDomain + "/api/articles/" + this.articleId + "/external_services")
            .then(function (res) {
            return res.json().then(function (data) {
                _this.setState({
                    loadingState: requestState.READY,
                    communities: data.communities,
                    fullMediaName: _this.props.fullMediaName || data.configs.name,
                    locale: data.configs.language,
                    clickHandler: _this.props.clickHandler &&
                        _this.props.clickHandler.bind(_this.articleId),
                    paywallConfiguration: data.paywall,
                    paywallStatus: data.configs.paywall_status,
                    gtmId: data.configs.gtm_id,
                    statisticsConfigs: data.statistics
                });
            });
        })
            .catch(function () {
            console.group('@ta-interaktiv/react-masthead');
            console.warn('Error while loading article data. Default or implied' +
                ' values will be used.');
            console.groupEnd();
            _this.setState({
                loadingState: requestState.ERROR,
                clickHandler: function () { },
                paywallStatus: 0
            });
        });
    };
    PolymorphicMasthead.defaultProps = {
        clickHandler: defaultClickHandler,
        enablePaywall: true,
        defaultLanguage: 'de',
        paywallContainerId: 'paywall_container'
    };
    return PolymorphicMasthead;
}(Component));

export default PolymorphicMasthead;
export { PolymorphicMasthead as Masthead, PolymorphicMasthead, Masthead as PureMasthead };
//# sourceMappingURL=index.js.map
